export default __webpack_public_path__ + "static/media/TN_logo.50cf5643.webp";